import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import ThemeToggle from '../components/ThemeToggle';
import { getHostInfo } from '../lib/hosts';

/**
 * HOLDING PAGES for the terms of service and the privacy policy.
 *
 * ⚠️ THESE ARE NOT DRAFTS, AND NOTHING HERE IS TERMS. The sign-up screen carries the
 * agreement line every SaaS sign-up carries, and a link that goes nowhere is worse than no
 * link at all — so it lands somewhere that says plainly the document is being prepared and
 * gives an address to ask. See PAGES-NEEDED.md, which tracks both as launch blockers.
 *
 * ⚠️ DO NOT LET THIS QUIETLY BECOME THE FINISHED ARTICLE. The privacy policy in particular
 * is a UK GDPR obligation — HolidayHive processes employee names, work emails and absence
 * records, and sickness is special-category data. Replace this with something written or
 * reviewed by somebody who does this for a living.
 */
export const LegalHoldingPage = ({ title, blurb }) => (
  <div className="min-h-screen bg-background flex items-center justify-center p-4">
    <ThemeToggle iconOnly variant="ghost" className="fixed top-4 right-4 z-50 text-muted-foreground hover:text-foreground" />
    <div className="w-full max-w-lg">
      <div className="flex justify-center mb-8">
        <a href={getHostInfo().marketingOrigin} className="inline-flex">
          <Logo size={34} />
        </a>
      </div>
      <div className="card-hive p-8">
        <h1 className="font-heading text-3xl font-bold mb-3">{title}</h1>
        <p className="text-muted-foreground mb-4">{blurb}</p>
        <p className="text-muted-foreground mb-6">
          We're writing it properly rather than putting up something vague. In the meantime,
          if there's anything you need to know before you sign up — what we store, where it
          lives, or how to get it back — just ask and you'll get a straight answer.
        </p>
        <p className="mb-8">
          <a href="mailto:hello@holidayhive.co.uk" className="text-primary hover:underline">
            hello@holidayhive.co.uk
          </a>
        </p>
        <p className="text-muted-foreground">
          <Link to="/register" className="text-primary hover:underline">Back to sign up</Link>
        </p>
      </div>
    </div>
  </div>
);

export const TermsPage = () => (
  <LegalHoldingPage
    title="Terms of service"
    blurb="Our terms of service are being prepared and aren't published yet."
  />
);

export const PrivacyPage = () => (
  <LegalHoldingPage
    title="Privacy policy"
    blurb="Our privacy policy is being prepared and isn't published yet."
  />
);

export default LegalHoldingPage;
